<div class="form" [formGroup]="form">
  <nx-edit-multiselect-v2-input
    [formGroup]="form"
    [placeholder]="placeholder"
    formControlName="selected"  
    [options]="options"
    [panelWidhtFull]="true"
    [showLabel]="true"
    [maxSelectedLabels]="3"
    [optionLabel]="'scopedName'"
    [dataKey]="'id'"
    [label]="'Labels'">
    <ng-template nxTemplate="item" let-item>
      <div class="flex items-center space-x-2">
        <span 
          class="border h-3 w-5 shrink-0 rounded bg-[rgb(255,0,0)] border-white mr-1" 
          [ngStyle]="{ 'background': item.color }">
        </span>
        {{ item.scopedName }}
      </div>
    </ng-template>
  </nx-edit-multiselect-v2-input>
  
</div>
